import { ApprovalModelService } from "./ApprovalModelService";

export type { IApprovalModelService } from "./IApprovalModelService";

export const approvalModelService = new ApprovalModelService();
